export default __webpack_public_path__ + "static/media/allow-bmg-7.95953661.png";